export default __webpack_public_path__ + "static/media/close.8f13c040.svg";